import type { Subsidy } from "@legacy/models/Subsidy";

import { ModelOperator } from "./ModelOperator";
import { ModelOperatorOptions } from "./ModelOperatorOptions";

interface SubsidyOperatorOptions extends ModelOperatorOptions<Subsidy, {}, {}> {}

export class SubsidyOperator extends ModelOperator<Subsidy, SubsidyOperatorOptions, {}, {}, {}> {}
